import { type FC, useMemo } from 'react';

import { useListingContext } from '@/microfrontends/listing/shared/context/ListingContext';

import { useReduxSelector } from '@/packages/redux-state/store';
import { selectJsonQueryType } from '@/packages/redux-state/store/slices/jsonQuery/selectors/selectJsonQueryType';

import { AveragePriceSEOBlock } from './internal/components/AveragePriceSEOBlock';

export const AveragePriceSEOBlockContainer: FC = () => {
  const {
    seo: {
      view: { averagePrice },
    },
  } = useListingContext();

  const jsonQueryType = useReduxSelector(selectJsonQueryType);

  /**
   * @todo отприлить когда будет доработано на бэке
   */
  const isAveragePriceEnabled = useMemo(
    () => averagePrice && jsonQueryType.startsWith('commercial'),
    [averagePrice, jsonQueryType],
  );

  if (!isAveragePriceEnabled) {
    return null;
  }

  return <AveragePriceSEOBlock averagePrice={averagePrice} />;
};
